<template>
  <div class="blog__accordion">

    <div class="container">

        <div class="row">
            <template v-if="loading">
                <div class="col-12">
                    <div class="d-flex justify-content-center align-items-center">
                        <loader />
                    </div>
                </div>
            </template>
            <template v-else>
                <template v-if="!articles.length">
                    <div class="col-12">
                        <h3 class="d-flex justify-content-center align-items-center">
                            Статей нет
                        </h3>
                    </div>
                </template>
                <template v-else>

                    <div class="col-12 col-md-6">

                        <template v-if="screenWidth <= 768">
                            <div class="blog__accordion-item d-flex" v-for="(article, idx) in articles" :key="article.id">
                                
                                <div class="blog__accordion-right">

                                    <transition 
                                        name="accordion" mode="out-in"
                                        @enter="start"
                                        @after-enter="end"
                                        @before-leave="start"
                                        @after-leave="end">
                                    >
                                        <div v-show="active === idx">
                                            <div class="blog__accordion-image d-flex justify-content-center align-items-center" :key="active">
                                                <img :src="`/storage/${articles[active].main_image.path}`" alt="">
                                            </div>
                                            <h3 
                                                class="blog__accordion-title" v-text="article.title" 
                                            />
                                            <div class="blog__accordion-content">
                                                <div class="blog__accordion-descr" v-text="striptagsContent(article.content)"></div>
                                                <a :href="`/blog/${article.category.slug}/${article.slug}`" class="btn">Читать</a>
                                            </div>
                                        </div>

                                    </transition>

                                </div>

                            </div>

                            <div class="d-flex blog__accordion-navigation">
                                
                                <template v-for="(article, idx) in articles">

                                    <div :key="article.id"
                                        class="blog__accordion-bullet d-flex justify-content-center align-items-center"
                                        :class="{'blog__accordion-bullet--active': active === idx, 'blog__accordion-bullet--completed': active > idx}"
                                        @click.prevent="active = idx"
                                    >
                                        <svg width="100%" height="100%" v-if="screenWidth <= 576">
                                            <circle 
                                                r="17px" cx="50%" cy="50%" stroke-width="2" fill="transparent"
                                                :stroke-dasharray="circumference + ' ' + circumference"
                                            />
                                        </svg>
                                        <svg width="100%" height="100%" v-else>
                                            <circle 
                                                r="24px" cx="50%" cy="50%" stroke-width="2" fill="transparent"
                                                :stroke-dasharray="circumference + ' ' + circumference"
                                            />
                                        </svg>
                                    </div>

                                </template>

                            </div>

                        </template>
                        <template v-else>
                            <ul class="blog__accordion-block">

                                <li class="blog__accordion-item d-flex" v-for="(article, idx) in articles" :key="article.id">
                                    
                                    <div class="blog__accordion-left">
                                        
                                        <div 
                                            class="blog__accordion-bullet d-flex justify-content-center align-items-center"
                                            :class="{'blog__accordion-bullet--active': active === idx, 'blog__accordion-bullet--completed': active > idx}"
                                            @click.prevent="active = idx"
                                        >
                                            <svg width="100%" height="100%">
                                                <circle 
                                                    r="24px" cx="50%" cy="50%" stroke="red" stroke-width="2" fill="transparent"
                                                    :stroke-dasharray="circumference + ' ' + circumference"
                                                />
                                            </svg>
                                        </div>

                                    </div>

                                    <div class="blog__accordion-right">

                                        <h3 
                                            class="blog__accordion-title" v-text="article.title" 
                                            @click.prevent="active = idx"
                                        />

                                        <transition 
                                            name="accordion" mode="in-out"
                                            @enter="start"
                                            @after-enter="end"
                                            @before-leave="start"
                                            @after-leave="end">
                                        >
                                            <div class="blog__accordion-content" v-show="active === idx">
                                                <div class="blog__accordion-descr" v-text="striptagsContent(article.content)"></div>
                                                <a :href="`/blog/${article.category.slug}/${article.slug}`" class="btn">Читать</a>
                                            </div>
                                        </transition>

                                    </div>

                                </li>
                            </ul>                
                        </template>

                    </div>
                    <div class="col-md-6 d-none d-md-block">
                        <transition name="fade" mode="out-in">
                            <div class="blog__accordion-image d-flex justify-content-center align-items-center" :key="active">
                                <img :src="`/storage/${articles[active].main_image.path}`" alt="">
                            </div>
                        </transition>
                    </div>
                </template>
            </template>

        </div>
    </div>

  </div>
</template>

<script>

import { getPosts } from './api.js'
import Loader from '../LoaderBalls'

export default {
    name: "BlogAccordion",
    components: { Loader },
    data(){
        return{
            screenWidth: 0,
            loading: false,
            active: 0,
            articles: []
        }
    },

    created(){
        this.handleScreenWidth()
        window.addEventListener(
            'resize',
            this.handleScreenWidth
        )

    },

    destroyed(){

        window.removeEventListener(
            'resize',
            this.handleScreenWidth
        )

    },

    mounted(){
        this.fetchArticles()
            .then( this.handleStartTimer )
    },
    TIMEOUT: 10000,
    computed: {

        activeLastArticle(){
            return this.active === this.articles.length - 1
        },

        radius() {
            let val = this.screenWidth <= 768 ? 35 : 50
            return val / 2;
        },

        circumference() {
            return (this.radius * 2 * Math.PI).toFixed(2);
        },

    },

    methods: {

        handleStartTimer(){
            let { articles } = this
            let { TIMEOUT } = this.$options

            if( articles.length > 1 ){

                setInterval(
                    () =>  {
                        if( this.activeLastArticle ) return this.active = 0
                        this.active += 1
                    }, 
                    TIMEOUT 
                )

            }

        },

        handleScreenWidth(){
            this.screenWidth = window.innerWidth
        },

        start(el) {
            el.style.height = el.scrollHeight + "px";
        },

        end(el) {
            el.style.height = "";
        },

        striptagsContent( content ) {
            return (content).replace(/<\/?[^>]+(>|$)/g, "")
        },

        async fetchArticles () {
            this.loading = true
            try{ 
                const params = { per_page: 3, only_favorite: 1 }
                let { data, success } = await getPosts({ params })
                
                if( success ) {
                    this.articles = data
                    this.loading = false
                }

            } catch ( e ){
                this.loading = false
            }
        }

    }

}
</script>
